const currentYear = new Date().getFullYear();

const locale = {
    code: "fr",
    label: "Français",
    NAV_BAR: {
        home: "Accueil",
        homeId: "home",
        aboutus: "À propos",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "Contact",
        contactId: "contact-section",
        button: "Accès anticipé",
    },

    HERO: {
        heroHeading: "Votre menu, accessible instantanément",
        heroParagraph:
            "Créez, mettez à jour et partagez votre menu avec un seul code QR — sans tracas, sans réimpression.",
        button: "Accès anticipé",
        downloadText: "Télécharger sur",
        appStore: "App Store",
        getItOn: "OBTENEZ-LE SUR",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Nos services",
        cards: [
            {
                title: "Créer et télécharger le menu",
                description:
                    "Créez et téléchargez facilement votre menu en quelques clics ! Ajoutez des éléments, fixez des prix et mettez à jour les détails sans compétences techniques.",
            },
            {
                title: "Mettre à jour le menu",
                description:
                    "Mettez à jour votre menu en temps réel à tout moment ! Modifiez les prix, ajoutez de nouveaux plats ou archivez les éléments indisponibles instantanément.",
            },
            {
                title: "Générer et partager",
                description:
                    "Générez instantanément un code QR unique pour votre menu ! Partagez-le sur des tables, des affiches ou en ligne pour que les clients accèdent à votre menu le plus récent.",
            },
        ],
    },

    FEATURES: {
        heading: "Découvrez nos fonctionnalités exceptionnelles",
        lists: [
            {
                title: "Gérer le menu",
                description:
                    "Gérez votre menu à tout moment ! Ajoutez, modifiez ou supprimez des éléments facilement pour garder votre offre à jour.",
            },
            {
                title: "Analyses et rapports",
                description:
                    "Obtenez des informations précieuses avec des rapports en temps réel ! Suivez les vues du menu, les scans de QR et les interactions client.",
            },
            {
                title: "Partager des QR codes",
                description:
                    "Partagez votre menu avec un code QR unique ! Affichez-le sur des tables, des affiches ou en ligne pour que les clients le scannent instantanément.",
            },
            {
                title: "Avis clients",
                description:
                    "Mettez en valeur les retours clients réels et les notes ! Renforcez la confiance, améliorez votre menu et optimisez l'expérience client.",
            },
            {
                title: "Offres et remises",
                description:
                    "Stimulez les ventes avec des offres spéciales et des remises ! Mettez en avant les promotions limitées et les offres exclusives.",
            },
        ],
    },

    ABOUT: {
        heading: "À propos de My QR Menu",
        headingPara: "Simplifiez la gestion du menu de votre restaurant avec des mises à jour en temps réel.",
        highlightHeading: "Accès rapide et facile à tout ce dont vous avez besoin",
        highlightPara: "Toutes vos fonctionnalités de menu — d'un simple toucher.",
        cards: {
            left: {
                heading: ["Ajoutez facilement des ingrédients", "à votre menu QR"],
                alt: "Ajouter des ingrédients",
            },
            right: {
                heading: ["Accédez facilement", "à votre tableau de bord menu"],
                alt: "Tableau de bord du menu",
            },
        },
    },

    FAQ: {
        heading: "Vous avez des questions. Nous avons des réponses.",
        subheading: "Tout ce que vous devez savoir sur le produit.",
        items: [
            {
                question: "Qu'est-ce que My QRMenu ?",
                answer:
                    "My QRMenu est une plateforme de menu numérique qui permet aux restaurants de créer, mettre à jour et partager instantanément leurs menus à l'aide de codes QR.",
            },
            {
                question: "Puis-je mettre à jour mon menu après l'avoir créé ?",
                answer:
                    "Oui, vous pouvez mettre à jour votre menu à tout moment et il sera instantanément visible lorsque les clients scanneront votre code QR.",
            },
            {
                question: "Comment fonctionne My QRMenu ?",
                answer:
                    "Vous créez un menu, générez un code QR et les clients le scannent pour voir la version la plus récente.",
            },
            {
                question: "Comment partager mon code QR ?",
                answer:
                    "Vous pouvez partager le code QR numériquement ou l'imprimer pour l'afficher dans votre restaurant.",
            },
            {
                question: "My QRMenu est-il optimisé pour les mobiles ?",
                answer:
                    "Oui, My QRMenu est optimisé pour tous les appareils, y compris les téléphones et les tablettes.",
            },
            {
                question: "Puis-je collecter des avis clients ?",
                answer:
                    "Oui, vous pouvez activer les avis clients et utiliser leurs retours pour améliorer votre offre.",
            },
        ],
    },

    CONTACT: {
        heading: "Contactez-nous",
        subheading: "Notre équipe amicale se fera un plaisir de vous aider.",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        message: "Message",
        firstNamePlaceholder: "Prénom",
        lastNamePlaceholder: "Nom",
        emailPlaceholder: "vous@entreprise.com",
        messagePlaceholder: "Écrivez votre message...",
        privacyConsent: "Vous acceptez notre",
        privacyPolicy: "politique de confidentialité",
        submitButton: "Envoyer le message",
        toast: {
            requiredConsent: "Vous devez accepter la politique de confidentialité.",
            submitting: "Envoi du message...",
            success: "Message envoyé avec succès !",
            fail: "Échec de l'envoi du message. Veuillez réessayer.",
            error: "Une erreur s'est produite. Veuillez vérifier votre connexion.",
        },
    },

    HELP_PAGE: {
        title: "Centre d'aide",
        description: "Si vous avez des questions ou avez besoin d'aide, contactez-nous à ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "Ou consultez nos FAQ ci-dessous, vous trouverez peut-être ce que vous cherchez.",
    },

    FOOTER: {
        footerHeading: "Menus numériques fluides, simplifiés !",
        footerButton: "Rejoindre la liste d'attente",
        footerConnect: "Connectez-vous avec nous",
        footerTerms: "Termes et accords",
        footerHelp: "Centre d'aide",
        footerPrivacy: "Politique de confidentialité",
        footerCopyright: `©${currentYear} Tous droits réservés.`,
    },

    PRIVACY_POLICY: {
        title: "Politique de Confidentialité",
        lastUpdated: "Dernière mise à jour : 22 mai 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                Cette politique de confidentialité décrit Nos politiques et procédures sur la collecte, l'utilisation et la divulgation de Vos informations lorsque Vous utilisez le Service.
                </p>
                <p class="mb-6 leading-relaxed">
                Nous utilisons Vos données personnelles pour fournir et améliorer le Service. En utilisant le Service, Vous acceptez la collecte et l'utilisation d'informations conformément à cette Politique de Confidentialité.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Interprétation et Définitions</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Interprétation</h3>
                <p class="mb-6 leading-relaxed">
                    Les mots dont la lettre initiale est en majuscule ont des significations définies dans les conditions suivantes.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Définitions</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Compte</strong> signifie un compte unique créé pour que Vous puissiez accéder à notre Service.</li>
                    <li><strong>Société</strong> désigne <strong>My QR Menu,</strong> Londres, Royaume-Uni.</li>
                    <li><strong>Données Personnelles</strong> désigne toute information relative à une personne identifiée ou identifiable.</li>
                    <li><strong>Vous</strong> désigne la personne qui accède au Service ou l'utilise.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Contactez-nous</h2>
                <p>
                Si vous avez des questions sur cette politique de confidentialité, vous pouvez nous contacter :
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>Par e-mail : <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Conditions Générales",
        lastUpdated: "Dernière mise à jour : 22 mai 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Veuillez lire attentivement ces conditions générales avant d'utiliser notre application ou notre site Web.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Interprétation et Définitions</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Interprétation</h3>
            <p class="leading-relaxed mb-4">
            Les mots dont la lettre initiale est en majuscule ont des significations définies dans les conditions suivantes.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Définitions</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Application</strong> désigne le logiciel fourni par My QR Menu.</li>
            <li><strong>Société</strong> désigne My QR Menu, basée à Londres, au Royaume-Uni.</li>
            <li><strong>Service</strong> désigne l'Application et le site Web.</li>
            <li><strong>Vous</strong> désigne la personne ou l'entreprise accédant au Service.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Reconnaissance</h2>
            <p class="leading-relaxed mb-6">
            En accédant ou en utilisant le Service, vous acceptez d'être lié par ces conditions. Si vous n'êtes pas d'accord, vous ne pouvez pas accéder au Service.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Liens vers d'autres sites Web</h2>
            <p class="leading-relaxed mb-6">
            Notre Service peut contenir des liens vers des sites tiers. Nous n'assumons aucune responsabilité quant à leur contenu ou leurs pratiques.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Résiliation</h2>
            <p class="leading-relaxed mb-6">
            Nous nous réservons le droit de résilier ou de suspendre votre accès au Service immédiatement, sans préavis, pour quelque raison que ce soit.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Limitation de Responsabilité</h2>
            <p class="leading-relaxed mb-6">
            Dans la mesure maximale permise par la loi, la Société ne sera pas tenue responsable des dommages résultant de votre utilisation du Service.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. Clause de non-responsabilité "TEL QUEL" et "SELON DISPONIBILITÉ"</h2>
            <p class="leading-relaxed mb-6">
            Le Service vous est fourni "TEL QUEL" et "SELON DISPONIBILITÉ". Nous ne garantissons pas qu'il sera sans erreur ou ininterrompu.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Loi Applicable</h2>
            <p class="leading-relaxed mb-6">
            Ces conditions sont régies par les lois du Royaume-Uni.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Résolution des litiges</h2>
            <p class="leading-relaxed mb-6">
            En cas de litige, vous acceptez de tenter une résolution informelle avant d'entreprendre une action en justice.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. Pour les utilisateurs de l'Union Européenne (UE)</h2>
            <p class="leading-relaxed mb-6">
            Si vous êtes un consommateur dans l'UE, vous bénéficiez des dispositions obligatoires de la loi de votre pays de résidence.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. Conformité légale aux États-Unis</h2>
            <p class="leading-relaxed mb-6">
            Vous déclarez et garantissez que vous ne vous trouvez pas dans un pays soumis à des sanctions du gouvernement américain.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Divisibilité et Renonciation</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Divisibilité</h3>
            <p class="leading-relaxed mb-4">
            Si une disposition de ces conditions est jugée inapplicable, les autres dispositions resteront en vigueur.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Renonciation</h3>
            <p class="leading-relaxed mb-6">
            Le fait de ne pas faire appliquer une disposition ne constitue pas une renonciation à ce droit.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Interprétation de la traduction</h2>
            <p class="leading-relaxed mb-6">
            Ces conditions ont pu être traduites. En cas de litige, la version anglaise prévaut.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Modifications de ces conditions</h2>
            <p class="leading-relaxed mb-6">
            Nous pouvons mettre à jour ces conditions à tout moment. Nous vous en informerons en publiant un avis sur notre site Web.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Contactez-nous</h2>
            <p class="leading-relaxed mb-2">Si vous avez des questions sur ces conditions, vous pouvez nous contacter :</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>Par e-mail : <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
